export const dataEnrollmentStatus = [
    { id: "fullTime", en: { name: "Full-time" }, fr: { name: "Temps plein" } },
    { id: "partTime", en: { name: "Part-time" }, fr: { name: "Temps partiel" } },
    { id: "leaveOfAbsence", en: { name: "Leave of Absence" }, fr: { name: "Congé" } },
    { id: "deferred", en: { name: "Deferred" }, fr: { name: "Reporté" } },
    { id: "graduated", en: { name: "Graduated" }, fr: { name: "Diplômé" } },
    { id: "other", en: { name: "Other" }, fr: { name: "Autre" } }
];
